/**
 * Environment Detection Utilities
 * Ported from: innovation-claude/poc/mfe-auth/src/models/app_context_view_model.rs:489-509
 *
 * Detects Tradovate stage and organization from browser hostname
 */

import type { TradovateStage } from '../config/types'

/**
 * Detect Tradovate stage from hostname
 * Matches legacy Environment.tsx:167-174 behavior
 *
 * From app_context_view_model.rs:489-499
 *
 * @param hostname - Browser hostname (e.g., "localhost", "trader-d.tradovate.com")
 * @returns Detected stage
 */
export function detectStageFromHostname(hostname: string): TradovateStage {
    if (hostname.includes('localhost') || hostname.includes('-d.')) {
        return 'Devel'
    } else if (hostname.includes('staging')) {
        return 'Staging'
    } else if (hostname.includes('uat')) {
        return 'UAT'
    } else {
        return 'Production'
    }
}

/**
 * Detect organization from hostname
 * tradovate.com → null (default)
 * ninjatrader.com → "NTB"
 *
 * From app_context_view_model.rs:501-509
 *
 * @param hostname - Browser hostname
 * @returns Organization code or null for Tradovate
 */
export function detectOrganization(hostname: string): string | null {
    if (hostname.includes('ninjatrader.com') || hostname.includes('ninjatrader.dev')) {
        return 'NTB'
    }
    return null  // Tradovate is default
}
